/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungserstellAntragDto } from '../../models/buchungserstell-antrag-dto';

export interface GetAllErstellAntraegePaginated$Plain$Params {
  ZeigeBearbeitete?: boolean;
  MitarbeiterName?: string;
  FuerMonteure?: string;

/**
 * Nummer der Seite die angezeigt werden soll.
 */
  PageNumber?: number;

/**
 * Anzahl der Einträge pro Seite. Maximal 100
 */
  PageSize?: number;

/**
 * Sortierung der Ergebnisse vor dem Filtern im Format: <br></br>(attribut) [(asc | desc)], ...(attribut) [(asc |
 * desc)],
 */
  OrderBy?: string;
}

export function getAllErstellAntraegePaginated$Plain(http: HttpClient, rootUrl: string, params?: GetAllErstellAntraegePaginated$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllErstellAntraegePaginated$Plain.PATH, 'get');
  if (params) {
    rb.query('ZeigeBearbeitete', params.ZeigeBearbeitete, {});
    rb.query('MitarbeiterName', params.MitarbeiterName, {});
    rb.query('FuerMonteure', params.FuerMonteure, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('OrderBy', params.OrderBy, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungserstellAntragDto>>;
    })
  );
}

getAllErstellAntraegePaginated$Plain.PATH = '/v1/buchungserstellAntraege';
